export interface CalculoFGTSResponse{
    valorFinal: number;
    meses: number;
    depositomensal:number;
    depositoTotal:number;
    saldoCorrigido: number;

}
export interface ResultCalculoFGTS{
    valorFinal: number;
    meses: number;
    depositomensal:number;
    depositoTotal:number;
    saldoCorrigido: number;
}

export interface CaluculoFGTSInput {
readonly saldo_Anterior : string
}


export const Explicaçoes_Campos = {
    saldo_Anterior : "Saldo já acumulado na sua conta do FGTS, consulte o extrato da Caixa para saber esse valor.",
    calculo_corrigido: "FGTS atualizado com depósitos e correção (juros/TR)"
} as const;